import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { selectGlobalLoading } from 'app/store/ui/ui.selectors';

@Component({
    selector: 'pulse-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PulseMainComponent implements OnInit, OnDestroy {
    isLoggedIn: boolean;
    hideHFO: boolean = false;
    @HostBinding('attr.pulse-layout-mode') layoutMode;
    loadingVisible = false;
    private unsubscribe$ = new Subject<void>();

    constructor(private store: Store, private cdr: ChangeDetectorRef) {
        const url = window.location.href;
        this.hideHFO = url.includes('candidate-digital-attestation');
    }

    ngOnInit() {
        this.store.select(selectGlobalLoading).pipe(
            delay(300),
            takeUntil(this.unsubscribe$)
        ).subscribe(value => {
            this.loadingVisible = !!value;
            this.cdr.markForCheck();
        });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
